import PropTypes from "prop-types";
import { Component, memo } from "react";

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import ModalDialogUtil from "../../utils/ModalDialogUtil";

/**
 * Reusable Confrimataion compoment.
 * props: onConfirm(function, required) - it will be called when user click on confirm.
 *        data(Object) - Data will be passed to onConfirm function as an argument.
 */

const DefaultIcon = memo(() => <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />);

class ConfirmDialog extends Component {
  /**
   * Method will be called when user click on confirm button,
   * and this method will hide the dialog, and after that call props.onConfirm function;
   */
  onConfirm() {
    //when user click on X, we are triggering [ducks].hideModal
    this.props.onConfirmDialog(this.props.data, this.props.surveyAdminLink);
    this.callHideModal(true);
  }

  title() {
    let { dialogTitle } = this.props;
    return !dialogTitle || dialogTitle === "" ? "app.confirmDialog.defaultTitle" : dialogTitle;
  }

  callHideModal() {
    ModalDialogUtil.closeModalDialogBodyFix();
    //when user click on X, we are triggering [ducks].hideDialog
    this.props.hideDialog();
  }

  specialLeaveFunction() {
    let { specialCancelFunction, hideDialog } = this.props;
    //special function for saving without exit the runner in this case
    specialCancelFunction();

    //when user click on X, we are triggering [ducks].hideDialog
    hideDialog();
  }

  // In case of leaving runner without save hide modal and runner
  callDismissRunner() {
    this.props.hideDialog();
    this.props.hideRunner();
  }

  render() {
    let { sendingDataIsInProgress, specialCancelFunction } = this.props;
    return (
      <Modal show={this.props.show} size="lg" onHide={specialCancelFunction ? this.specialLeaveFunction.bind(this) : this.callHideModal.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.icon || <DefaultIcon />}
            &nbsp;
            <FormattedMessage id={this.title()} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormattedMessage id={this.props.dialogText} />
        </Modal.Body>
        <Modal.Footer className={this.props.dismissLabel === "dialog.leave.without.saving" ? "survey-runner" : ""}>
          {this.props.confirmLabel === "dialog.leave" ? (
            <Button variant="secondary" as={Link} to={this.props.data.action} onClick={this.callHideModal.bind(this)}>
              <FormattedMessage id={this.props.confirmLabel} />
            </Button>
          ) : (
            <Button disabled={sendingDataIsInProgress} onClick={this.onConfirm.bind(this)} variant="primary">             
              <FormattedMessage id={this.props.confirmLabel} />
            </Button>
          )}
          {specialCancelFunction ? (
            <Button variant="secondary" onClick={this.specialLeaveFunction.bind(this)}>
              <FormattedMessage id={this.props.dismissLabel} />
            </Button>
          ) : this.props.dismissLabel === "dialog.leave.without.saving" ? (
            <Button variant="warning" onClick={this.callDismissRunner.bind(this)}>
              <FormattedMessage id={this.props.dismissLabel} />
            </Button>
          ) : (
            this.props.dismissLabel && (
              <Button variant="secondary" onClick={this.callHideModal.bind(this)}>
                <FormattedMessage id={this.props.dismissLabel} />
              </Button>
            )
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmDialog.propTypes = {
  onConfirm: PropTypes.func,
  data: PropTypes.object,
  dialogTitle: PropTypes.string,
  dialogText: PropTypes.string,
  confirmLabel: PropTypes.string,
  dismissLabel: PropTypes.string,
  onConfirmDialog: PropTypes.func,
  specialCancelFunction: PropTypes.func,
  show: PropTypes.bool,
  hideDialog: PropTypes.func,
  surveyAdminLink: PropTypes.string,
  hideRunner: PropTypes.func,
  icon: PropTypes.element,
  sendingDataIsInProgress: PropTypes.bool
};
export default ConfirmDialog;
